import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Core } from "@faire/design-tokens";
import { DefaultTheme } from "./DefaultTheme";
import { eventsThemeColors } from "./eventsThemeColors";
export var checkboxEventsTheme = _object_spread_props(_object_spread({}, DefaultTheme.checkboxes), {
    primary: _object_spread_props(_object_spread({}, DefaultTheme.checkboxes.primary), {
        icon: Core.icon.inverse,
        fill: eventsThemeColors.faireMarket.primaryDark,
        border: eventsThemeColors.faireMarket.primaryDark,
        borderActive: Core.border.default,
        base: {
            variant: "paragraphSansRegular",
            color: Core.text.subdued
        },
        checked: {
            variant: "paragraphSansRegular",
            color: eventsThemeColors.faireMarket.primaryLight
        },
        hover: {
            variant: "paragraphSansRegular",
            color: eventsThemeColors.faireMarket.primaryDark
        }
    })
});
